module.exports = {"clubLogo":"Golf Club Logo"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/footer.json
// module id = JFGS
// module chunks = 2